import React, {Component} from 'react'
import {Redirect} from 'react-router';

import HttpClient from './HttpClient'

import Select from 'react-select';
import GooglePermissionPopup from './GooglePermissionPopup';
import {Modal, Popover, PopoverBody} from 'reactstrap';
import {Button, Tooltip} from 'antd';
import {uniqBy} from 'lodash';
import {ClearOutlined} from '@ant-design/icons';
import googlePermissionsHtml from "@/helpers/GooglePermissionHTML";


export default class GoogleAnalyticsPropertySelect extends Component {

    constructor(props) {
        super(props)
        this.state = {
            allProperties: [],
            allManualClient: [],
            allGroupPropertiesOrClient: [],
            isAccountLinked: true,
            isPermissionPopupOpened: false,
            selectedProperties: [],
            showUpgradePopup: false,
            swalOpened: false,
            currentUser: {},
        };
        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.loadUser = this.loadUser.bind(this);
        this.deleteKeyword = this.deleteKeyword.bind(this);
        this.clearAllProperties = this.clearAllProperties.bind(this);
        this.searchGoogleAnalyticsProperties = this.searchGoogleAnalyticsProperties.bind(this);
    }

    componentDidMount() {
        this.searchGoogleAnalyticsProperties(' ', (options) => {
            if (options.length) {
                if (this.props.autoSelectFirst) {
                    setTimeout(() => {
                        this.onChangeHandler(options[0]);
                    }, 5000);
                }
            }
            this.setState({allProperties: options}, () => {
                if (this.props.selectedIds && this.props.selectedIds?.length) {
                    const selectedIds = this.props.selectedIds || []; // Ensure selectedIds is an array

                    const selectedProperties = selectedIds.map((selectedId) => {
                        const selectedProperty = this.state.allProperties.find(
                            (property) => selectedId === property.value
                        );

                        return selectedProperty
                            ? {
                                ...selectedProperty,
                                value: selectedProperty.value,
                                label: selectedProperty.labelText,
                                wasLastDataFetchingSuccessful: true,
                            }
                            : null;
                    });

                    this.setState({selectedProperties});
                }
            });
        });
        this.loadUser();
    }

    loadUser = async () => {
        const response = await HttpClient.get('/user');
        const price_plan = response.data.user.price_plan;
        this.setState({
            currentUser: response.data.user,
            price_plan
        });

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props != prevProps) {
            if (this.props.aProperties && this.props.aProperties.length) {
                this.searchGoogleAnalyticsProperties(' ', (options) => {
                    const currentSelectedProperties = this.props.aProperties.map(sO => {
                        return {
                            value: sO.value,
                            label: sO.label || options.find(gap => gap.value == sO.value)?.labelText,
                        }
                    });

                    this.setState({selectedProperties: currentSelectedProperties})
                });

            }

            if (prevProps.selectedValue !== this.props.selectedValue) {
                const selectedProperty = this.state.allProperties.find(property => this.props.selectedValue === property.value);

                const finalSelectedProperty = selectedProperty?.value ? [{
                    ...selectedProperty,
                    value: selectedProperty.value,
                    label: selectedProperty.labelText,
                    wasLastDataFetchingSuccessful: true
                }] : [];

                this.setState({selectedProperties: finalSelectedProperty})
            }
        }
    }

    deleteKeyword(propertyId) {
        // this.onChangeHandler(null);
        const filteredProperty = this.state.selectedProperties.filter(itm => itm.value != propertyId);
        this.setState({selectedProperties: filteredProperty});
        if (filteredProperty.length === 0) {
            if (this.props.multiple) {
                this.props.onChangeCallback({
                    target: {
                        name: this.props.name,
                        value: [""],
                        wasLastDataFetchingSuccessful: true
                    }
                });
            }

            if (this.props.multiple) {
                this.props.onChangeCallback({
                    target: {
                        name: this.props.name,
                        value: [""],
                        wasLastDataFetchingSuccessful: true
                    }
                });
            }

            if (this.props.onChangeCallback2) {
                this.props.onChangeCallback2([]);
            }
        } else {
            if (this.props.multiple) {
                this.props.onChangeCallback({
                    target: {
                        name: this.props.name,
                        value: filteredProperty.map(sO => sO.value),
                        wasLastDataFetchingSuccessful: true
                    }
                });
            }

            if (this.props.multiple) {
                this.props.onChangeCallback({
                    target: {
                        name: this.props.name,
                        value: filteredProperty.map(sO => sO.value),
                        wasLastDataFetchingSuccessful: true
                    }
                });
            }
            if (this.props.onChangeCallback2) {
                this.props.onChangeCallback2(filteredProperty);
            }
        }
    }

    async searchGoogleAnalyticsProperties(keyword, callback) {
        try {
            const response = await HttpClient.get('settings/google-analytics-property?keyword=' + keyword);
            const manualClients = await HttpClient.get('/manual-client-website');
            const groupPropertiesClients = await HttpClient.get('/group-properties-or-clients');
            let gaps = response.data.google_analytics_properties;
            let hasLimitedAccess = response.data.is_allowed_access_to_all_properties;
            let options = gaps.map(gap => {
                return {
                    value: gap.id,
                    labelText: gap.name + ' ' + gap.google_analytics_account.name,
                    wasLastDataFetchingSuccessful: gap.was_last_data_fetching_successful,
                    isInUse: gap.is_in_use,
                    label: (
                        <div className="d-flex propertyLabel">
                            <span style={{background: "#2d9cdb"}} className="dot"></span>
                            <span className="text-truncate"
                                  style={{maxWidth: 400}}>{gap.name + ' ' + gap.google_analytics_account.name}
                                {/*{!gap.has_refresh_token &&
                                    <span style={{color: 'rgba(204,106,118,0.37)'}}> - Not Connected</span>}*/}
                            </span>
                        </div>
                    )
                };
            });

            let mcs = manualClients.data.data;
            let mcsOptions = []
            if (!this.props.hideClientWebsite) {
                mcsOptions = mcs.map(mc => {
                    return {
                        value: `${mc.id}_manual`,
                        labelText: mc.client_name + ' - Manual ',
                        isInUse: mc.is_in_use,
                        label: (
                            <div className="d-flex propertyLabel">
                                <span style={{background: "#2d9cdb"}} className="dot"></span>
                                <span className="text-truncate" style={{maxWidth: 400}}>
                                {mc.client_name}
                                    <span style={{color: 'rgba(69,136,118,0.72)'}}> - Manual</span>
                            </span>
                            </div>
                        )
                    }
                });
            }

            let gpc = groupPropertiesClients.data.data;
            let gpcOptions = []
            if (!this.props.hideGroups) {
                gpcOptions = gpc.map(mc => {
                    return {
                        value: `${mc.id}_group`,
                        labelText: mc.group_name + ' - Group ',
                        isInUse: false,
                        label: (
                            <div className="d-flex propertyLabel">
                                <span style={{background: "#2d9cdb"}} className="dot"></span>
                                <span className="text-truncate"
                                      style={{maxWidth: 400}}>{mc.group_name} <span
                                    style={{color: 'rgba(55,91,117,0.93)'}}> - Group</span> </span>
                            </div>
                        )
                    };
                });
            }

            this.setState({allManualClient: mcs, allGroupPropertiesOrClient: gpcOptions, hasLimitedAccess})

            // Combine and sort the options
            let combinedOptions = [...options, ...mcsOptions, ...gpcOptions].sort((a, b) => {
                return a.labelText.localeCompare(b.labelText);
            });

            callback(combinedOptions);
        } catch (err) {
            if (err.response && err.response.status === 400) {
                this.setState({isAccountLinked: false});
            } else {
                this.setState({errors: err});
            }
        }
    }

    onChangeHandler(sOption) {
        if (sOption.value === '') {
            return ''
        }

        let finalSelectedProperty = []
        if (this.props.multiple) {
            const selectedVal = sOption;
            finalSelectedProperty = uniqBy([...this.state.selectedProperties, ...selectedVal.map(itm => ({
                ...itm,
                value: itm.value,
                label: itm.labelText
            }))], 'value');
            this.setState({selectedProperties: finalSelectedProperty})
        } else {
            const selectedVal = sOption;
            finalSelectedProperty = [{
                ...selectedVal,
                value: selectedVal.value,
                label: selectedVal.labelText,
                wasLastDataFetchingSuccessful: true
            }]
            this.setState({selectedProperties: finalSelectedProperty})
        }

        if (
            (!this.props.skipLimit && (this.state.currentUser.price_plan.google_analytics_property_count < (
                    this.state.allProperties.filter(sO => sO.isInUse).length
                    + finalSelectedProperty.filter(sO => !sO.isInUse).length))
            )
            && (this.state.currentUser.price_plan.google_analytics_property_count !== 0)
        ) {
            this.setState({showUpgradePopup: true})
        } else {
            if (this.props.multiple) {
                this.props.onChangeCallback({
                    target: {
                        name: this.props.name,
                        value: finalSelectedProperty.map(sO => sO.value),
                        wasLastDataFetchingSuccessful: true
                    }
                });
            }

            if (!this.props.multiple) {
                this.props.onChangeCallback({
                    target: {
                        name: this.props.name,
                        value: finalSelectedProperty[0].value,
                        wasLastDataFetchingSuccessful: sOption.wasLastDataFetchingSuccessful
                    }
                });
            }

            if (this.props.onChangeCallback2) {
                this.props.onChangeCallback2(finalSelectedProperty);
            }
        }
    }

    onFocusHandler = (e) => {
        if (this.props.onFocus) {
            this.props.onFocus();
        }

        // Only open swal if it has not been opened yet and the account is not linked
        if (!this.state.isAccountLinked && !this.state.swalOpened) {
            this.setState({swalOpened: true}, () => {
                swal.fire({
                    iconHtml: '<figure class="m-0"><img src="/images/google-account.svg"></figure>',
                    html: googlePermissionsHtml,
                    width: 500,
                    confirmButtonText: `Connect Google Account`,
                    focusConfirm: false,
                    showCloseButton: false,
                    allowOutsideClick: true,
                    backdrop: true,
                    customClass: {
                        popup: "confirmConnectionTo",
                        htmlContainer: "confirmConnectionToContent",
                        closeButton: 'btn-closeplanAlertPopup',
                    },
                }).then(value => {
                    console.log("=>(GoogleAnalyticsPropertySelect.js:354) value", value);

                    if (value.isConfirmed) {
                        localStorage.setItem("frontend_redirect_to", window.location.pathname);
                        var redirect_url = window.location.pathname;

                        let query_string_obj = {
                            'google_analytics_perm': document.getElementById('google_analytics_perm') ? document.getElementById('google_analytics_perm').checked : true,
                            'google_search_console_perm': document.getElementById('google_search_console_perm') ? document.getElementById('google_search_console_perm').checked : true,
                            'google_ads_perm': document.getElementById('google_ads_perm') ? document.getElementById('google_ads_perm').checked : true,
                            'redirect_url': redirect_url,
                        }
                        if (this.props.popupCheck) {
                            localStorage.setItem("popupCheck", this.props.popupCheck);
                        }
                        let query_string = new URLSearchParams(query_string_obj).toString();
                        window.location = "/settings/google-account/create?" + query_string;
                    } else if (value.isDismissed) {
                        setTimeout(() => {
                            this.setState({swalOpened: false});
                        }, 1000)
                    }
                });
            });

        }
    }

    clearAllProperties() {
        this.setState({selectedProperties: []}, () => {
            if (this.props.multiple) {
                this.props.onChangeCallback({
                    target: {
                        name: this.props.name,
                        value: [],
                        wasLastDataFetchingSuccessful: true
                    }
                });
            }

            if (this.props.onChangeCallback2) {
                this.props.onChangeCallback2([]);
            }
        });
    }


    render() {
        if (this.state.redirectTo) return <Redirect to={this.state.redirectTo}/>

        return (
            <>
                <div>
                    <Modal isOpen={this.state.showUpgradePopup} centered className="gaUpgradePopup"
                           toggle={() => this.setState({showUpgradePopup: false, upgradePopupType: ''})}>
                        <button onClick={() => this.setState({showUpgradePopup: false, upgradePopupType: ''})}
                                class="btn-closeUpgradePopup"><img src="/images/close.svg" alt="close icon"/></button>
                        <ga-upgrade-popup
                            heading={`<h1>Upgrade today to add <span>more properties</span></h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            button={`<a href="https://calendly.com/crystal-ball/30min" target="_blank" class="btn-bookAdemo">Book a Demo</a>`}
                            bannerImg="/images/more-property-upgrade.svg"
                        >
                        </ga-upgrade-popup>

                    </Modal>

                    <div className="themeNewInputStyle position-relative inputWithIcon">
                        {!this.props.hideIcon ?
                            <i className="icon fa" onClick={this.props.onChangeCallbackIcon}>
                                <img src='/icon-plus.svg'/>
                            </i>
                            : null
                        }
                        <Select
                            menuPosition={'fixed'}
                            onFocus={this.onFocusHandler}
                            // onKeyDown={this.onFocusHandler}
                            loadOptions={this.searchGoogleAnalyticsProperties}
                            noOptionsMessage={() => {
                                return "No Property"
                            }}
                            className={`${this.props.className} ga-account-select-holder`}
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    width: 500,
                                }),
                            }}
                            name={this.props.name}
                            disabled={this.props.disabled}
                            // value={this.state.aProperties}
                            value={this.props.multiple ? [] : this.state.selectedProperties}
                            id={this.props.id}
                            isMulti={this.props.multiple}
                            isClearable={this.props.isClearable}
                            onChange={this.onChangeHandler}
                            options={this.state.allProperties}
                            isSearchable={true}
                            placeholder={this.props.placeholder}
                            filterOption={(option, inputValue) => {
                                if (!inputValue) return true;

                                const value = option.data.labelText.toLowerCase();
                                return value.includes(inputValue.toLowerCase());
                            }}
                            components={this.props.components}
                        />
                        {
                            this.state.isPermissionPopupOpened ? <GooglePermissionPopup/> : ''
                        }
                    </div>


                    <div className='ga-analytics-property-selected'>
                        {!this.props.minimal && this.state.selectedProperties.length && this.props.multiple ? <h4>
                            <div className="flex justify-between">
                                Selected properties:
                                {this.state.selectedProperties.length ? (
                                    <Tooltip title="Clear All">
                                        <Button
                                            size="small"
                                            type="text"
                                            icon={<img src="/icon-trash.svg"/>}
                                            onClick={this.clearAllProperties}
                                        />
                                    </Tooltip>
                                ) : null}
                            </div>
                            <span>(Click to remove)</span>
                        </h4> : null}
                        {this.state.selectedProperties.length && this.props.multiple ?
                            <div className="d-flex keywordTags mt-3">
                                {this.state.selectedProperties.map(itm => {
                                    return (<div key={itm.value}>
                                        <button
                                            onClick={() =>
                                                this.setState({
                                                    activeDeletePopover: itm.value,
                                                })
                                            }
                                            id={"gAK-" + itm.value}
                                            type="button"
                                            className="keywordTag"
                                            key={itm.value}
                                            user_data_source_id={itm.value}
                                        >
                                        <span
                                            style={{background: "#2d9cdb"}}
                                            className="dot"
                                        ></span>
                                            <span className="text-truncate ga-selected-label"
                                                  style={{maxWidth: this.props.minimal ? 80 : 150}}>{itm.labelText || itm.label}</span>
                                        </button>

                                        <Popover
                                            placement="top"
                                            target={"gAK-" + itm.value}
                                            isOpen={
                                                this.state.activeDeletePopover ===
                                                itm.value
                                            }
                                        >
                                            <PopoverBody web_monitor_id={itm.value}>
                                                Are you sure you want to remove "{itm.labelText || itm.label}"?.
                                            </PopoverBody>
                                            <button
                                                onClick={() => this.deleteKeyword(itm.value)}
                                                key={itm.value}
                                                user_data_source_id={itm.value}
                                            >
                                                Yes
                                            </button>
                                            <button
                                                onClick={() =>
                                                    this.setState({
                                                        activeDeletePopover: null,
                                                    })
                                                }
                                            >
                                                No
                                            </button>
                                        </Popover>
                                    </div>)
                                })}
                            </div> : null}
                    </div>
                </div>
            </>
        )
    }
}
